const state = {
  page: 1,
  all: [],
  isLoading: false,
  disablePagination: false,
  filter: null,
  allDeliveriesSelected: false,
  requestDetails: {},
  requestPage: 1,
  materialFilter: null,
  masterVehicleList: [],
  masterTransporterList: [],
  noFreightTransporterList: [],
  mdmGateList: [],
  transporterPagination: 1,
  gateListingPagination: 1,
  materialsAvailable: true,
};
export default state;
